import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  constructor(private afAuth: AngularFireAuth, private fb: FormBuilder) { }

  formPasswordReset: FormGroup = this.fb.group({
    email: [null, [Validators.required, Validators.email]]
  });

  ngOnInit(): void {
  }

  sendPasswordResetRequest() {
    const email = this.formPasswordReset.controls['email'].value
    this.afAuth.sendPasswordResetEmail(email).then(() => {
      alert('Correo para resetear contraseña enviado')
    },
      err => {
        console.log(err)
      }
    );
  }

}
